import { StickyNote, Mail, Phone, ListChecks, CalendarDays, Flag, Cog } from 'lucide-react'
import type { Activity, ActivityType } from '@/types/entities'
import { date } from '@/lib/format'

const ICON: Record<ActivityType, typeof Mail> = {
  Note: StickyNote, Email: Mail, Call: Phone, Task: ListChecks,
  Meeting: CalendarDays, Milestone: Flag, System: Cog,
}

/** Activity timeline (record center column). Newest first. */
export function Timeline({ activities }: { activities: Activity[] }) {
  const sorted = [...activities].sort((a, b) => (a.at < b.at ? 1 : -1))
  if (!sorted.length) return <div className="timeline-empty dim">No activity logged yet.</div>
  return (
    <div className="timeline">
      {sorted.map((a) => {
        const Icon = ICON[a.type] ?? StickyNote
        return (
          <div key={a.id} className="tl-item">
            <div className={`tl-icon tl-icon--${a.type.toLowerCase()}`}><Icon size={14} /></div>
            <div className="tl-body">
              <div className="tl-head">
                <span className="tl-title">{a.title}</span>
                <span className="tl-time">{date(a.at, 'med')}</span>
              </div>
              {a.body && <div className="tl-text">{a.body}</div>}
              <div className="tl-meta">
                <span className="tl-type">{a.type}</span>
                {a.actor && <span className="tl-actor">· {a.actor}</span>}
                {a.tags?.map((t) => <span key={t} className="tl-tag">{t}</span>)}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
